//const noCache = process.env.NO_CACHE === 'true' || process.env.NO_CACHE === 'True' || process.env.NO_CACHE === 'TRUE'
const noCache = true;
export default noCache;
